import { render, staticRenderFns } from "./LoanProjectionChart.vue?vue&type=template&id=36c4cf7c&scoped=true&"
import script from "./LoanProjectionChart.vue?vue&type=script&lang=ts&"
export * from "./LoanProjectionChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4cf7c",
  null
  
)

export default component.exports